export default __webpack_public_path__ + "static/media/gallery_05.28a9df1c.jpg";